<template>
  <div id="bscpage1-view">
    <dv-full-screen-container>
      <div style="width: 100%; height: 10%">
        <topHeader name="topHeader" :PageTitle="PageTitle" ActiveMenuIndex="5.3"></topHeader>
      </div>
      <div style="width: 100%; height: 90%;" class="main-content">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="实时监测" name="first" class="top-item">
            <page1></page1>
          </el-tab-pane>
          <el-tab-pane label="综合评价" name="second" class="top-item">
            <page2></page2>
          </el-tab-pane>
          <el-tab-pane label="负载分析" name="third" class="top-item">
            <page3></page3>
          </el-tab-pane>
          <el-tab-pane label="电流不平衡" name="fourth" class="top-item">
            <page4></page4>
          </el-tab-pane>
          <el-tab-pane label="电压合格率" name="five" class="top-item">
            <page5></page5>
          </el-tab-pane>
          <el-tab-pane label="功率因数" name="six" class="top-item">
            <page6></page6>
          </el-tab-pane>
          <el-tab-pane label="变压器参数" name="seven" class="top-item">
            <page7></page7>
          </el-tab-pane>
          <el-tab-pane label="变压器经济运行" name="enght" class="top-item" >
            <page8></page8>
          </el-tab-pane>
        </el-tabs>
      </div>
    </dv-full-screen-container>
  </div>
</template>
<script>
import topHeader from "../TopMenu/topHeader";
import page1 from "./page1";
import page2 from "./page2";
import page3 from "./page3";
import page4 from "./page4";
import page5 from "./page5";
import page6 from "./page6";
import page7 from "./page7";
import page8 from "./page8";
export default {
  components: {
    topHeader,
    page1,
    page2,
    page3,
    page4,
    page5,
    page6,
    page7,
    page8,
  },
  data() {
    return {
      PageTitle: '变压器实时监测与经济运行',
      dialogVisible: false,
      dialogRemoveButtonDisabled: true,
      activeName: "first",
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>
<style scoped>
#bscpage1-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;
  #dv-full-screen-container {
    background-image: url("../../Imag/bg.png");
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }
  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .block-top-button-content {
    flex: 1;
    height: 3%;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-bottom-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }
  .block-top-mid {
    height: 35%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-content {
    height: 50%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .block-top-button {
    height: 5%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
  .el-select .el-input__inner {
    background-color: rgba(0, 0, 0, 0) !important;
    border: 0;
  }
}

</style>
<style>
.el-tabs__item {
    padding: 0 20px;
    height: 40px;
    box-sizing: border-box;
    line-height: 40px;
    display: inline-block;
    list-style: none;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    position: relative;
}
</style>